import { render, staticRenderFns } from "./TaxReturnTableHeader.vue?vue&type=template&id=450a92e5&scoped=true&"
import script from "./TaxReturnTableHeader.vue?vue&type=script&lang=js&"
export * from "./TaxReturnTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a92e5",
  null
  
)

export default component.exports